<template>
  <div
    v-show="activeNotifications.length"
    class="notifications"
  >
    <transition-group name="notifications">
      <div
        v-for="n in activeNotifications"
        :key="n.id"
        class="notifications-item"
      >
        <ui-notification
          class="notifications-item__notification"
          closable
          :title="n.title"
          :color="n.color"
          :type="n.type"
          :on-shown="n.onShown"
          :on-close="n.onClose"
          @remove="REMOVE_NOTIFICATION(n.id)"
        >
          <!-- eslint-disable vue/no-v-html -->
          <span class="notifications-item__message" v-html="sanitize(n.message)" />
          <!-- eslint-enable vue/no-v-html -->
        </ui-notification>
      </div>
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { sanitize } from '@/utils/sanitize';

export default defineComponent({
  setup() {
    return {
      sanitize,
    };
  },

  computed: {
    ...mapGetters({
      NOTIFICATIONS: 'notifications/list',
    }),

    activeNotifications() {
      return this.NOTIFICATIONS.slice(0, 4);
    },
  },

  methods: {
    ...mapActions({
      REMOVE_NOTIFICATION: 'notifications/remove',
    }),
  },
});
</script>

<style lang="scss">
.notifications {
  @include stacking("notifications");
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  padding: 24px 10px;

  .ui-notification {
    margin: 0 0 12px;
  }

  /* transition */
  .notifications-item {
    transition: all .4s ease;

    &__message {
      color: $black;
    }
  }

  &-enter-active,
  &-leave-to {
    transform: translateX(0);
    max-height: 112px;
  }
  &-enter,
  &-leave-active {
    transform: translateX(120%);
    max-height: 0;
  }
}

@include breakpoint("tablet") {
  .notifications {
    box-sizing: content-box;
    width: 316px;
    padding: 24px;
  }
}

@include breakpoint("desktop") {
  .notifications {
    box-sizing: content-box;
    width: 316px;
    padding: 32px;

    .ui-notification {
      margin: 0 0 16px;
    }
  }
}

</style>
